import Provider from '@/shared/types/fulfilment/provider.type';
import ProviderAmazonFBA from '@/shared/types/fulfilment/providerAmazonFBA.type';

import FulfilmentProviderDetails from '../types/fulfilmentProviderDetails.type';

export type FormState = {
  fulfilmentProviderDetails: FulfilmentProviderDetails;
  fulfilmentProviderDetailsErrors: Partial<FulfilmentProviderDetails>;
  providerFBADetails: ProviderAmazonFBA;
  providerFBADetailsErrors: Partial<ProviderAmazonFBA>;
};

export type FormAction =
  | {
      type: 'SET_FULFILMENT_PROVIDER_DETAILS';
      payload: FulfilmentProviderDetails;
    }
  | {
      type: 'SET_FULFILMENT_PROVIDER_DETAILS_ERRORS';
      payload: Partial<FulfilmentProviderDetails>;
    }
  | {
      type: 'SET_PROVIDER_FBA_DETAILS';
      payload: ProviderAmazonFBA;
    }
  | {
      type: 'SET_PROVIDER_FBA_DETAILS_ERRORS';
      payload: Partial<ProviderAmazonFBA>;
    };

const createInitialState =
  (initialState: Provider | null = null) =>
  (): FormState => {
    return {
      fulfilmentProviderDetails: {
        provider_name: initialState?.provider_name || '',
        provider_description: initialState?.provider_description || '',
        fulfilment_provider_key: initialState?.fulfilment_provider_key || '',
        is_auto_fulfil: initialState?.is_auto_fulfil || false,
        is_force_inventory_sync: initialState?.is_force_inventory_sync || false,
        fulfilment_delay_time: initialState?.fulfilment_delay_time || '7200',
        fulfilment_update_interval:
          initialState?.fulfilment_update_interval || '2400',
      },
      fulfilmentProviderDetailsErrors: {
        fulfilment_provider_key: '',
        provider_name: '',
        provider_description: '',
      },
      providerFBADetails: {
        market_place_id: initialState?.market_place_id || '',
        refresh_token: initialState?.refresh_token || '',
        lwa_app_id: initialState?.lwa_app_id || '',
        lwa_client_secret: initialState?.lwa_client_secret || '',
        aws_secret_key: initialState?.aws_secret_key || '',
        aws_access_key: initialState?.aws_access_key || '',
        role_arn: initialState?.role_arn || '',
      },
      providerFBADetailsErrors: {
        lwa_client_secret: '',
        lwa_app_id: '',
        refresh_token: '',
        market_place_id: '',
      },
    };
  };

const reducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case 'SET_FULFILMENT_PROVIDER_DETAILS':
      return { ...state, fulfilmentProviderDetails: action.payload };
    case 'SET_FULFILMENT_PROVIDER_DETAILS_ERRORS':
      return { ...state, fulfilmentProviderDetailsErrors: action.payload };
    case 'SET_PROVIDER_FBA_DETAILS':
      return { ...state, providerFBADetails: action.payload };
    case 'SET_PROVIDER_FBA_DETAILS_ERRORS':
      return { ...state, providerFBADetailsErrors: action.payload };
    default:
      return state;
  }
};

export { createInitialState, reducer };
